module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/local_product_benefit.931c7f4137.png";